export const menuItems = [
    { title: "Главная", link: "/main" },
    {
        title: "Программы",
        link: "/treatment",
        submenu: [
            { title: "Профильная", link: "/treatment" },
            { title: "Здоровое сердце", link: "/treatment" },
            { title: "Легкое дыхание", link: "/treatment" },
            { title: "Гармония души", link: "/treatment" },
            { title: "Мужское здоровье", link: "/treatment" },
            { title: "Женское здоровье", link: "/treatment" },
            { title: 'Здоровые суставы', link: "/treatment" },
            { title: 'Кладовая жизненных сил', link: "/treatment" },
        ]
    },
    {
        title: "СПА",
        link: "/spa",
        submenu: [
            { title: "СПА - капсула", link: "/spa" },
            { title: "Пилинги", link: "/spa" },
            { title: "Массажи", link: "/spa" },
            { title: "Фитотермотерапия", link: "/spa" },
            { title: "Аппаратная липосакция", link: "/spa" },
            { title: "Безинъекционная мезотерапия", link: "/spa" },
        ]
    },
    {
        title: "Номера",
        link: "/rooms",
    },
    {
        title: "Услуги",
        link: "/food",
        submenu: [
            { title: "Досуг", link: "/food" },
            { title: "Инфраструктура", link: "/food" }
        ]
    },
    {title: "Информация",link: "/info",}
];